// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';
import { numberFormatMixins } from '@/app/mixins/modules/number-format-mixins';
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';

// Services
import BreedService from '@/app/services/main/breeds/breeds-service';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

// Component
const ModalFindReplaceWithBreedName = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-find-replace-with-breed-name"*/ '@/app/views/main-view/breeds/containers/modals/modal-find-replace-with-breed-name/modal-find-replace-with-breed-name.vue');


export default {
	name: 'BreedAddEditComponent',
	components: {
		ModalFindReplaceWithBreedName
	},
	mixins: [
		toastMessageMixins,
		numberFormatMixins,
		inputTextMixins
	],
	data() {
		return {
			sizeList: [
				{
					id: 2,
					name: 'Small'
				},
				{
					id: 3,
					name: 'Medium'
				},
				{
					id: 4,
					name: 'Large'
				}
			],
			// Loaders
			isEditAPILoading: false,
			isAPILoading: false,
			nameDuplicateWarning: false,
			checkNameLoading: false,

			// Form fields
			breedName: '',
			oldBreedName: '',
			selectedSize: '',
			status: true,
			adultAge: 0,
			maleWeightMin: 0,
			maleWeightMax: 0,
			femaleWeightMin: 0,
			femaleWeightMax: 0,
			milestones: {
				general: '',
				health: '',
				exercise: '',
				p6m: '',
				p9m: '',
				p12m: '',
				p18m: '',
				p2y: ''	
			},
			breedEditDetails: {
				breedName: '',
				selectedSize: '',
				status: 0,
				adultAge: 0,
				maleWeightMin: 0,
				maleWeightMax: 0,
				femaleWeightMin: 0,
				femaleWeightMax: 0,
				milestones: {
					general: '',
					health: '',
					exercise: '',
					p6m: '',
					p9m: '',
					p12m: '',
					p18m: '',
					p2y: ''	
				}
			},
			
			isBreedInsert: false
		}
	},
	computed: {
		validationRules() {
			let fields = {
				breedName: {},
				selectedSize: {},
				adultAge: {},
				maleWeightMin: {},
				maleWeightMax: {},
				femaleWeightMin: {},
				femaleWeightMax: {}
			};
			fields = vuelidateUtil.setRequiredValidation(fields, 'breedName');
			fields = vuelidateUtil.setRequiredValidation(fields, 'selectedSize');
			fields = vuelidateUtil.setRequiredValidation(fields, 'adultAge');
			fields = vuelidateUtil.setMinValueValidation(fields, 'adultAge', 0);
			fields = vuelidateUtil.setMinValueValidation(fields, 'maleWeightMin', 0);
			fields = vuelidateUtil.setMinValueValidation(fields, 'maleWeightMax', 0);
			fields = vuelidateUtil.setMinValueValidation(fields, 'femaleWeightMin', 0);
			fields = vuelidateUtil.setMinValueValidation(fields, 'femaleWeightMax', 0);

			return fields;
		},
		compareFields() {
			const compareBreedName = this.breedEditDetails.breedName !== this.breedName;
			const compareSelectedSize = this.breedEditDetails.selectedSize !== this.selectedSize;
			const compareStatus = this.breedEditDetails.status !== this.status;
			const compareAdultAge = this.breedEditDetails.adultAge !== this.adultAge;
			const compareMaleWeightMin = this.breedEditDetails.maleWeightMin !== this.maleWeightMin;
			const compareMaleWeightMax = this.breedEditDetails.maleWeightMax !== this.maleWeightMax;
			const compareFemaleWeightMin = this.breedEditDetails.femaleWeightMin !== this.femaleWeightMin;
			const compareFemaleWeightMax = this.breedEditDetails.femaleWeightMax !== this.femaleWeightMax;

			const compareMilestones = (this.breedEditDetails.milestones.general !== this.milestones.general 
				|| this.breedEditDetails.milestones.health !== this.milestones.health
				|| this.breedEditDetails.milestones.exercise !== this.milestones.exercise
				|| this.breedEditDetails.milestones.p6m !== this.milestones.p6m
				|| this.breedEditDetails.milestones.p9m !== this.milestones.p9m
				|| this.breedEditDetails.milestones.p12m !== this.milestones.p12m
				|| this.breedEditDetails.milestones.p18m !== this.milestones.p18m
				|| this.breedEditDetails.milestones.p2y !== this.milestones.p2y);

			return !(compareBreedName || compareSelectedSize || compareStatus || compareAdultAge 
				|| compareMaleWeightMin || compareMaleWeightMax || compareFemaleWeightMin || compareFemaleWeightMax
				|| compareMilestones )
		},
		isInvalid() {
			if(this.$route.name === 'Add Breed') {
				return this.$v.$invalid || this.isAPILoading || this.nameDuplicateWarning || this.maleWeightInvalid || this.femaleWeightInvalid;	
			}
			else if(this.$route.name === 'Edit Breed') {
				return this.compareFields || this.$v.$invalid || this.isAPILoading || this.nameDuplicateWarning || this.maleWeightInvalid || this.femaleWeightInvalid;
			}
			else if(this.$route.name === 'Copy Breed') {
				return !this.isBreedNameChanged || this.$v.$invalid || this.isAPILoading || this.nameDuplicateWarning || this.maleWeightInvalid || this.femaleWeightInvalid;
			}
		},
		isBreedNameChanged() {
			return this.breedName != this.oldBreedName;
		},
		maleWeightInvalid() {
			return parseFloat(this.maleWeightMax) < parseFloat(this.maleWeightMin);
		},
		femaleWeightInvalid() {
			return parseFloat(this.femaleWeightMax) < parseFloat(this.femaleWeightMin);
		}
	},
	created() {
		if (this.$route.params.id) {
			this.getBreedInfoForEdit();
		}
	},
	methods: {
		nameKeyUp() {
			this.delayTyping(() => {
				if (this.breedName !== '') {
					if(this.isBreedNameChanged) {
						this.getBreedByNameAPI();
					} else {
						this.nameDuplicateWarning = false;
					}
				}
			});
		},
		onBlur() {
			this.$v.selectedSize.$touch();
		},
		onSubmit(source) {
			if (this.$v.$invalid || this.nameDuplicateWarning) {
				return;
			}
			let formattedMilestones = this.formatMilestonesOnSubmit(this.milestones);
			const breedDetails = {
				name: this.breedName,
				breedSizeId: this.selectedSize,
				adultAge: this.adultAge,
				maleMinWeight: this.maleWeightMin,
				maleMaxWeight: this.maleWeightMax,
				femaleMinWeight: this.femaleWeightMin,
				femaleMaxWeight: this.femaleWeightMax,
				status: this.status ? 'A': 'I',
				milestone: {
					GENERAL: formattedMilestones.general,
					HEALTH: formattedMilestones.health,
					EXERCISE: formattedMilestones.exercise,
					P6M: formattedMilestones.p6m,
					P9M: formattedMilestones.p9m,
					P12M: formattedMilestones.p12m,
					P18M: formattedMilestones.p18m,
					P2Y: formattedMilestones.p2y
				}
			}
			let endpoint = 'saveBreed';
			let text = 'save';

			if (source === 'Edit Breed') {
				breedDetails.id = this.$route.params.id;
				endpoint = 'updateBreed';
				text = 'update';
			}
			if (source === 'Copy Breed') {
				breedDetails.id = this.$route.params.id;
			}

			BreedService[endpoint](breedDetails)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.showCustomSuccessToast(`${this.breedName} has been ${text}d!`);
						this.$router.push('/breed-management');
					} else {
						this.showAPIErrorToast(`Unable to ${text} breed.`, res);
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
				})
				.finally(() => {
					this.isAPILoading = false;
				});
		},
		getBreedInfoForEdit() {
			BreedService.getBreedById(this.$route.params.id)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.breedEditDetails = res.data;
						this.setModelToUpdate(res.data);
					} else {
						this.showAPIErrorToast('Unable to get breed details.', res);
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
				})
				.finally(() => {
					this.isAPILoading = false;
				});
		},
		setModelToUpdate(data) {
			this.breedName = data.name;
			this.oldBreedName = data.name;
			this.selectedSize = data.breedSizeId;
			this.status = data.status === 'A';
			this.adultAge = Math.trunc(data.adultAge);
			this.maleWeightMin = data.maleMinWeight;
			this.maleWeightMax = data.maleMaxWeight;
			this.femaleWeightMin = data.femaleMinWeight;
			this.femaleWeightMax = data.femaleMaxWeight;

			for (const key in data.milestone) {
				const e = data.milestone[key];
				switch (e.infoTypeCode) {
					case 'GENERAL':
						this.milestones.general = e.description;
						break;
					case 'HEALTH':
						this.milestones.health = e.description;
						break;
					case 'EXERCISE':
						this.milestones.exercise = e.description;
						break;
					case 'P6M':
						this.milestones.p6m = e.description;
						break;
					case 'P9M':
						this.milestones.p9m = e.description;
						break;
					case 'P12M':
						this.milestones.p12m = e.description;
						break;
					case 'P18M':
						this.milestones.p18m = e.description;
						break;
					case 'P2Y':
						this.milestones.p2y = e.description;
						break;
				}
			}
			this.breedEditDetails = {
				breedName: this.breedName,
				selectedSize: this.selectedSize,
				status: this.status,
				adultAge: this.adultAge,
				maleWeightMin: this.maleWeightMin,
				maleWeightMax: this.maleWeightMax,
				femaleWeightMin: this.femaleWeightMin,
				femaleWeightMax: this.femaleWeightMax,
				milestones: JSON.parse(JSON.stringify(this.milestones))
			}
		},
		getBreedByNameAPI() {
			const queryParams = {
				page: 1,
				limit: 1,
				f_name: this.breedName
				
			}
			this.checkNameLoading = true;
			this.isAPILoading = true;
			BreedService.getBreedList(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						const tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
						};
						this.nameDuplicateWarning = tableContent.tableData.length > 0 ;

					} else {
						this.showAPIErrorToast('Unable to fetch breeds list.', res);
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
				})
				.finally(() => {
					this.checkNameLoading = false;
					this.isAPILoading = false;
				});
		},
		showInsertBreedName() {
			this.isBreedInsert = !this.isBreedInsert;
		},
		insertBreedName(label) {
			if (this.milestones[label] == '') {
				this.milestones[label] = "BREED_NAME";
			}
			else {
				this.milestones[label] += " BREED_NAME";
			}
		},
		replaceBodyWithBreedName(newBody) {
			this.milestones = newBody;
		},
		showModalFindReplaceWithBreedName() {
			this.$refs.modalFindReplaceWithBreedName.show(this.milestones);
		},
		formatMilestonesOnSubmit(milestones) {
			for (const i in milestones) {
                if (milestones[i]) {
                    milestones[i] = milestones[i].replace(/BREED_NAME/g, this.breedName);
                }
            }
			return milestones;
		}
	},
	validations() {
		return this.validationRules;
	}
}